import { Link } from 'react-router-dom';
import RejectIcon from 'src/images/icons/cart-rejected-icon.svg?react';

type Props = {
  cartRequestedBy: string; // this will be their name, if no name then email
};

export const ReviewRejected = ({ cartRequestedBy }: Props) => {
  return (
    <div className='flex w-full flex-col items-center justify-center gap-6 bg-primary-dark py-16 sm:gap-8 sm:py-20 md:gap-10 md:py-24 lg:gap-12 lg:py-28'>
      <div className='flex w-full max-w-[650px] flex-col items-center justify-center gap-2 sm:gap-3 md:gap-4 lg:gap-6'>
        <RejectIcon />
        <h5 className='heading-500 text-offWhite'>Cart Rejected</h5>
        <p className='text-300 text-center text-blueGray'>
          We've sent a notification to {cartRequestedBy} to let them know the
          cart has been rejected. If you included any notes on why you rejected
          the cart, they will be included in the email.
        </p>
      </div>

      <Link to='/plus/cart-history'>
        <button className='button-primary h-12'>View All Carts</button>
      </Link>
    </div>
  );
};
